module.exports = __webpack_public_path__ + "img/193.aa466210.jpg";